import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.29 10.927a1.2 1.2 0 0 1 0 2.146l-15.14 7.57c-1.193.597-2.49-.597-1.996-1.835L5.878 12 3.154 5.192C2.66 3.954 3.957 2.76 5.15 3.356zM19.306 12 4.523 4.608l-.021-.007h-.007a.1.1 0 0 0-.028.015.1.1 0 0 0-.018.027v.007q-.001.003.005.022l2.753 6.882a1.2 1.2 0 0 1 0 .892l-2.753 6.882-.006.022.001.007a.1.1 0 0 0 .018.027q.02.014.028.015h.007q.004.001.021-.007z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.978 12.7H6.575v-1.4h13.403z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=SendIcon24.js.map